const initialState = {
  size: "small",
  depth: {
    text: "8",
    value: "8",
    priceToAdd: 0,
  },
};

const MettressCustomizations = (state = initialState, action) => {
  switch (action.type) {
    case "SET_METTRESS_SIZE":
      return {
        ...state,
        size: action.payload,
      };
    case "SET_METTRESS_DEPTH":
      return {
        ...state,
        depth: action.payload,
      };

    default:
      return state;
  }
};

export default MettressCustomizations;
